var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4898 10.5956V6.23138C32.4898 3.8211 30.5358 1.86719 28.1256 1.86719H6.30462C3.89434 1.86719 1.94043 3.8211 1.94043 6.23138V19.3239C1.94043 21.7342 3.89434 23.6881 6.30462 23.6881H10.6688M15.033 32.4165H36.8539C39.2642 32.4165 41.2181 30.4626 41.2181 28.0523V14.9598C41.2181 12.5495 39.2642 10.5956 36.8539 10.5956H15.033C12.6227 10.5956 10.6688 12.5495 10.6688 14.9598V28.0523C10.6688 30.4626 12.6227 32.4165 15.033 32.4165ZM30.3077 21.506C30.3077 23.9163 28.3537 25.8702 25.9435 25.8702C23.5332 25.8702 21.5793 23.9163 21.5793 21.506C21.5793 19.0958 23.5332 17.1419 25.9435 17.1419C28.3537 17.1419 30.3077 19.0958 30.3077 21.506Z",
    stroke: "#053F66",
    strokeWidth: 3.27314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.c234212ffedfa09c673fa03f6c28d635.svg";
export { ForwardRef as ReactComponent };